import { message as antdMessage } from 'antd';

// Cap stacked toasts so a burst of errors doesn't
// pile the screen with messages faster than they can be read/dismissed.
antdMessage.config({ maxCount: 3 });

export const Message = antdMessage;
export default Message;
